var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('img',{staticStyle:{"width":"300px","max-width":"100%"},attrs:{"src":"images/empty-box.svg"}}),_c('h5',{staticClass:"card-title m-t-10"},[_vm._v("Data tidak ditemukan")])])
}]

export { render, staticRenderFns }